<div class="min-h-screen bg-dark-900 text-white font-sans selection:bg-primary-500 selection:text-white relative">
  <!-- Navbar -->
  <app-navbar></app-navbar>

  <!-- Main Content Route -->
  <main class="container mx-auto px-4 py-8">
    <router-outlet></router-outlet>
  </main>

  <app-toast></app-toast>
  <app-modal></app-modal>
</div>